export type IToken = string;

export enum IDataType {
    string = 'string',
    number = 'number',
    bool = 'bool',
    array = 'array',
    object = 'object',
}
